import { atom } from 'recoil';

const categoryErrorAtom = atom({
  key: 'categoryError',
  default: { Name: '', Order: '' }
});

export { categoryErrorAtom };
